import React, {createContext, useEffect, useReducer} from 'react';
import {projectAuth} from "../firebase/config";

export const AuthContext = createContext()

// authReducer is responsible for updating my states
export const authReducer = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            return { ...state, user:action.payload }
        case "LOGOUT":
            return { ...state, user:null }
        case 'AUTH_IS_READY':
            return { ...state, user: action.payload, authIsReady: true }
        default:
            return state
    }
}

// wrapped in the index.js to make available to all children
export const AuthContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(authReducer, {
        user:null,
        authIsReady: false
    })

    useEffect(() => {
    const unsub = projectAuth.onAuthStateChanged(user => {
      dispatch({ type: 'AUTH_IS_READY', payload:user })
      unsub()
    })
    }, [])


    return (
        <AuthContext.Provider value={{...state, dispatch}}>
            {children}
        </AuthContext.Provider>
    );
};

